import { EZoneCodes } from '@/_types';

export const getZone = (zoneCode: EZoneCodes, host: string): string => {
  const isSubComDomain = host.includes('.wildberries.com.tr');
  const isTurkishStageDomain = host.includes(
    '.portal-stage.wildberries.com.tr',
  );
  const isWildberriesStageDomain = host.includes(
    `.portal-stage.wildberries.${zoneCode}`,
  );

  if (isSubComDomain) {
    if (isTurkishStageDomain) {
      return '.portal-stage.wildberries.com.tr';
    }

    return `.wildberries.com.${zoneCode}`;
  }

  if (isWildberriesStageDomain) {
    return `.portal-stage.wildberries.${zoneCode}`;
  }

  return host.includes('.wildberries')
    ? `.wildberries.${zoneCode}`
    : `.wb.${zoneCode}`;
};
